import 'core-js/stable'
import 'regenerator-runtime/runtime.js'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// @ts-ignore
import MetaInfo from 'vue-meta-info'
import Component from 'vue-class-component'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import '@/assets/styles/bootstrap.scss'
import '@/assets/styles/main.css'

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(MetaInfo)
Component.registerHooks(['metaInfo'])
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: (h) => h(App),
  mounted() {
    document.dispatchEvent(new Event('render-event'))
  }
}).$mount('#app')
